export default import.meta.ROLLDOWN_FILE_URL_5morDHkKMDwb5L3PNpMy3Q